import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareAgentContextRoute: InvariantJiraRoute = {
	name: 'software-agent-context',
	exact: true,
	path: '/jira/software/projects/:projectKey/agent-context',
};
